import BesselChart from "./BesselChart";
import { homeStateSelector, setHomeState } from "@/store/redux/modules/home";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { debounce, getWeatherDomainType, isTestLink, pxChangeVw } from "@/utils";
import { fetchDataMap } from "@/components/BasicLayout/BasicHeader/Navigation";
import { refreshUserLocation } from "@/components/BasicLayout/BasicHeader/LocationMask";
import ArrowLeft from "@assets/icons/arrow_left.svg?react";
import ArrowRight from "@assets/icons/arrow_right月相.svg?react";
import lodash from "lodash";
import NewMoon from "@assets/img/NewMoon.png";
import WaxingCrescent from "@assets/img/WaxingCrescent.png";
import FirstQuarter from "@assets/img/FirstQuarter.png";
import WaxingGibbous from "@assets/img/WaxingGibbous.png";
import Full from "@assets/img/Full.png";
import WaningGibbous from "@assets/img/WaningGibbous.png";
import Last from "@assets/img/Last.png";
import WaningCrescent from "@assets/img/WaningCrescent.png";
import { Skeleton } from "antd-mobile";
import ErrorPage from "@/components/ErrorPage";
import useDateFormat from "@/hooks/useDateFormat";
import { useTranslation } from "react-i18next";
const SunMoonDefault: React.FC = () => {
  const { t: $t } = useTranslation();
  const [data, setData] = useState<any>({});
  const homeState = useSelector(homeStateSelector);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const localSelectCity = LocalStorage.getItem("select_city");
  const [isShowErrorPage, setIsShowErrorPage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const fetchData = async (keyId: any = undefined, type: string | undefined = undefined) => {
    try {
      const resData: any = await sunMoonApi.query({
        test: isDevEnv ? 1 : undefined,
        keyId: keyId || localSelectCity?.Key || homeState?.info?.key || LocalStorage.getItem("info")?.key,
        now_date: data?.now_date,
        type: type,
      });
      LocalStorage.setItem("info", resData.data.baseInfo);
      dispatch(setHomeState({ info: resData.data.baseInfo }));
      setData(lodash.omit(resData.data, ["baseInfo"]));
    } catch (error: any) {
      setIsShowErrorPage(() => true);
      setErrorMessage(() => error.message);
    }
  };
  fetchDataMap[pathname] = fetchData;
  useEffect(() => {
    if (!(homeState?.info?.key || LocalStorage.getItem("info")?.key || localSelectCity?.Key)) {
      refreshUserLocation(dispatch);
    } else {
      fetchData();
    }
  }, [homeState?.info?.key || LocalStorage.getItem("info")?.key]);
  const dayDiff = dayjs(data?.now_date).diff(dayjs().format("YYYY-MM-DD"), "day");
  const imgMap: any = {
    NewMoon,
    WaxingCrescent,
    FirstQuarter,
    WaxingGibbous,
    Full,
    WaningGibbous,
    Last,
    WaningCrescent,
  };
  const { enDomains, shortDate, supportedDomains } = useDateFormat();
  const sunMoonInfoSections = [
    isEmptyType(data) ? (
      <Skeleton
        animated
        style={{
          "--width": "100%",
          "--height": "260px",
          "--border-radius": "10px",
        }}
      />
    ) : (
      <WeatherMainContent className="content font-size-12">
        <StyleTitle>{$t("title06")}</StyleTitle>
        <div className="mb-32">
          <div className="mb-24">
            {!isEmptyType(data?.SunMoon?.Sun || data?.SunMoon?.Moon) && (
              <BesselChart SunMoon={{ ...data?.SunMoon, ...lodash.omit(data, ["SunMoon"]) }} />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-y-16">
          <div className="flex gap-x-24">
            <div className="flex-[1] flex items-center">
              <i className="flex-[1] inline-block color-[rgba(255,255,255,0.9)] text-left">{$t("title12")}</i>
              <i className="flex-[1] inline-block text-16 items-center">{data?.SunMoon?.Sun?.Rise}</i>
            </div>
            <div className="flex-[1] flex items-center">
              <i className="flex-[1] inline-block">{$t("title13")}</i>
              <i className="flex-[1] inline-block">{data?.SunMoon?.Sun?.Set}</i>
            </div>
          </div>
          <div className="flex gap-x-24">
            <div className="flex-[1] flex items-center">
              <i className="flex-[1] inline-block color-[rgba(255,255,255,0.9)] text-left">{$t("title14")}</i>
              <i className="flex-[1] inline-block text-16 items-center">{data?.SunMoon?.Moon?.Rise}</i>
            </div>
            <div className="flex-[1] flex items-center">
              <i className="flex-[1] inline-block">{$t("title15")}</i>
              <i className="flex-[1] inline-block relative">
                {data?.SunMoon?.Moon?.Set}
                {!!data?.SunMoon?.Moon?.NextDay && data?.SunMoon?.Moon.NextDay > 0 && (
                  <sub className="absolute text-10 bottom-0 right-[-2px]">+{data?.SunMoon?.Moon.NextDay}</sub>
                )}
              </i>
            </div>
          </div>
        </div>
      </WeatherMainContent>
    ),
    isEmptyType(data) ? (
      <Skeleton
        animated
        style={{
          "--width": "100%",
          "--height": "260px",
          "--border-radius": "10px",
        }}
      />
    ) : (
      <WeatherMainContent className="content text-12">
        <StyleTitle>{$t("title07")}</StyleTitle>
        <div
          className="flex justify-around items-center  border-b-1 border-b-solid border-b-[rgba(255,255,255,0.18)] pb-25"
          dir="auto"
        >
          <div>
            <ArrowLeft
              pointerEvents={dayDiff <= 0 ? "none" : "auto"}
              className="active:bg-[rgba(255,255,255,0.3)]"
              style={{
                width: pxChangeVw("40px"),
                opacity: dayDiff <= 0 ? 0.5 : 1,
              }}
              onClick={debounce(() => {
                fetchData(undefined, "pre");
              })}
            />
          </div>
          <div className="flex flex-col items-center gap-y-8 text-12">
            <WeatherImage className="w-60" prefix={false} src={imgMap?.[data?.SunMoon?.Moon?.PhaseType] ?? NewMoon} />
            <p>{data?.SunMoon?.Moon?.Phase}</p>
            <p style={{ opacity: 0.7 }}>
              {dayjs(data?.now_date || Date.now()).format(
                enDomains.includes(window.location.hostname)
                  ? "MMM DD, YYYY"
                  : supportedDomains.includes(window.location.hostname)
                  ? "DD/MM/YYYY"
                  : "YYYY-MM-DD"
              )}
            </p>
          </div>
          <div>
            <ArrowRight
              pointerEvents={dayDiff >= 9 ? "none" : "auto"}
              className="active:bg-[rgba(255,255,255,0.3)]"
              style={{
                width: pxChangeVw("40px"),
                opacity: dayDiff >= 9 ? 0.5 : 1,
              }}
              onClick={debounce(() => {
                fetchData(undefined, "next");
              })}
            />
          </div>
        </div>
        <div className="pt-20 flex color-[rgba(255,255,255,0.7)] text-12">
          <div className="flex-[1] text-center border-r-1 border-r-solid border-r-[rgba(255,255,255,0.18)]">
            <WeatherImage className="w-20 mb-10" src={Full} prefix={false} />
            <div>
              <p>{$t("title08")}</p>
              <p>
                {dayjs(data?.next_full_moon).format(
                  enDomains.includes(window.location.hostname) ? "MMM DD" : shortDate
                )}
              </p>
            </div>
          </div>
          <div className="flex-[1] text-center">
            <WeatherImage className="w-20 mb-10" src={NewMoon} prefix={false} />
            <div>
              <p>{$t("title09")}</p>
              <p>
                {dayjs(data?.next_new_moon).format(enDomains.includes(window.location.hostname) ? "MMM DD" : shortDate)}
              </p>
            </div>
          </div>
        </div>
      </WeatherMainContent>
    ),
  ];
  return isShowErrorPage ? (
    <ErrorPage
      errorMessage={errorMessage}
      refreshPage={() => {
        setIsShowErrorPage(() => false);
        fetchData();
      }}
    />
  ) : (
    <div className="flex flex-col justify-start gap-y-10 p-[0_16px] box-border">
      {(isTestLink([...domainMap["wi"], ...domainMap["wg"]]) ||
        [...domainMap["wi"], ...domainMap["wg"]].includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("320x100", 7)} />
      )}
      {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
        lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("300x250", 3)} />
      )}
      {getWeatherDomainType() === "24hweather.com" ? (
        <>
          {sunMoonInfoSections[1]}
          {sunMoonInfoSections[0]}
        </>
      ) : (
        <>
          {sunMoonInfoSections[0]}
          {sunMoonInfoSections[1]}
        </>
      )}
    </div>
  );
};
export default SunMoonDefault;
